export const actionTypes = {
  GET_SOD_CONFLICTS: "GET_SOD_CONFLICTS",
  GET_SOD_CONFLICTS_SUCCESS: "GET_SOD_CONFLICTS_SUCCESS",
  GET_SOD_CONFLICTS_FAILURE: "GET_SOD_CONFLICTS_FAILURE",

  DELETE_SOD_CONFLICT: "DELETE_SOD_CONFLICT",
  DELETE_SOD_CONFLICT_SUCCESS: "DELETE_SOD_CONFLICT_SUCCESS",
  DELETE_SOD_CONFLICT_FAILURE: "DELETE_SOD_CONFLICT_FAILURE",

  SET_SELECTED_CONFLICT: "SET_SELECTED_CONFLICT",

  GET_ALL_ENTITLEMENTS: "GET_ALL_ENTITLEMENTS",
  GET_ALL_ENTITLEMENTS_SUCCESS: "GET_ALL_ENTITLEMENTS_SUCCESS",
  GET_ALL_ENTITLEMENTS_FAILURE: "GET_ALL_ENTITLEMENTS_FAILURE",

  SET_SELECTED_ENTITLEMENTS: "SET_SELECTED_ENTITLEMENTS",

  CREATE_CONFLICT: "CREATE_CONFLICT",
  CREATE_CONFLICT_SUCCESS: "CREATE_CONFLICT_SUCCESS",
  CREATE_CONFLICT_FAILURE: "CREATE_CONFLICT_FAILURE",

  UPDATE_CONFLICT_TYPE: "UPDATE_CONFLICT_TYPE",
  UPDATE_CONFLICT_TYPE_SUCCESS: "UPDATE_CONFLICT_TYPE_SUCCESS",
  UPDATE_CONFLICT_TYPE_FAILURE: "UPDATE_CONFLICT_TYPE_FAILURE",

  GET_CONFLICT_EXCEPTIONS: "GET_CONFLICT_EXCEPTIONS",
  GET_CONFLICT_EXCEPTIONS_SUCCESS: "GET_CONFLICT_EXCEPTIONS_SUCCESS",
  GET_CONFLICT_EXCEPTIONS_FAILURE: "GET_CONFLICT_EXCEPTIONS_FAILURE",

  EDIT_CONFLICT_EXCEPTION: "EDIT_CONFLICT_EXCEPTION",
  EDIT_CONFLICT_EXCEPTION_SUCCESS: "EDIT_CONFLICT_EXCEPTION_SUCCESS",
  EDIT_CONFLICT_EXCEPTION_FAILURE: "EDIT_CONFLICT_EXCEPTION_FAILURE",

  DELETE_CONFLICT_EXCEPTIONS: "DELETE_CONFLICT_EXCEPTIONS",
  DELETE_CONFLICT_EXCEPTIONS_SUCCESS: "DELETE_CONFLICT_EXCEPTIONS_SUCCESS",
  DELETE_CONFLICT_EXCEPTIONS_FAILURE: "DELETE_CONFLICT_EXCEPTIONS_FAILURE",

  SET_CONFLICT_TO_MODIFY: "SET_CONFLICT_TO_MODIFY",

  GET_ALL_CREATE_EXCEPTION_USERS: "GET_ALL_CREATE_EXCEPTION_USERS",
  GET_ALL_CREATE_EXCEPTION_USERS_SUCCESS:
    "GET_ALL_CREATE_EXCEPTION_USERS_SUCCESS",
  GET_ALL_CREATE_EXCEPTION_USERS_FAILURE:
    "GET_ALL_CREATE_EXCEPTION_USERS_FAILURE",

  SET_CREATE_EXCEPTION_SELECTED_USERS: "SET_CREATE_EXCEPTION_SELECTED_USERS",

  CREATE_EXCEPTION: "CREATE_EXCEPTION",
  CREATE_EXCEPTION_SUCCESS: "CREATE_EXCEPTION_SUCCESS",
  CREATE_EXCEPTION_FAILURE: "CREATE_EXCEPTION_FAILURE",
};

export const getSodConflictsAction = () => ({
  type: actionTypes.GET_SOD_CONFLICTS,
});
export const getSodConflictsSuccessAction = (payload: any) => ({
  type: actionTypes.GET_SOD_CONFLICTS_SUCCESS,
  payload,
});
export const getSodConflictsFailureAction = (error: any) => ({
  type: actionTypes.GET_SOD_CONFLICTS_FAILURE,
  error,
});

export const deleteSodConflictAction = (payload: any) => ({
  type: actionTypes.DELETE_SOD_CONFLICT,
  payload,
});
export const deleteSodConflictSuccessAction = (payload: any) => ({
  type: actionTypes.DELETE_SOD_CONFLICT_SUCCESS,
  payload,
});
export const deleteSodConflictFailureAction = (error: any) => ({
  type: actionTypes.DELETE_SOD_CONFLICT_FAILURE,
  error,
});

export const setSelectedConflictAction = (payload: any) => ({
  type: actionTypes.SET_SELECTED_CONFLICT,
  payload,
});

export const getAllEntitlementsAction = (payload: any) => ({
  type: actionTypes.GET_ALL_ENTITLEMENTS,
  payload,
});
export const getAllEntitlementsSuccessAction = (payload: any) => ({
  type: actionTypes.GET_ALL_ENTITLEMENTS_SUCCESS,
  payload,
});
export const getAllEntitlementsFailureAction = (error: any) => ({
  type: actionTypes.GET_ALL_ENTITLEMENTS_FAILURE,
  error,
});

export const setSelectedEntitlementsAction = (payload: any) => ({
  type: actionTypes.SET_SELECTED_ENTITLEMENTS,
  payload,
});

export const createConflictAction = (payload: any) => ({
  type: actionTypes.CREATE_CONFLICT,
  payload,
});
export const createConflictSuccessAction = (payload: any) => ({
  type: actionTypes.CREATE_CONFLICT_SUCCESS,
  payload,
});
export const createConflictFailureAction = (error: any) => ({
  type: actionTypes.CREATE_CONFLICT_FAILURE,
  error,
});

export const updateConflictTypeAction = (payload: any) => ({
  type: actionTypes.UPDATE_CONFLICT_TYPE,
  payload,
});
export const updateConflictTypeSuccessAction = (payload: any) => ({
  type: actionTypes.UPDATE_CONFLICT_TYPE_SUCCESS,
  payload,
});
export const updateConflictTypeFailureAction = (error: any) => ({
  type: actionTypes.UPDATE_CONFLICT_TYPE_FAILURE,
  error,
});

export const getConflictExceptionsAction = (payload: any) => ({
  type: actionTypes.GET_CONFLICT_EXCEPTIONS,
  payload,
});
export const getConflictExceptionsSuccessAction = (payload: any) => ({
  type: actionTypes.GET_CONFLICT_EXCEPTIONS_SUCCESS,
  payload,
});
export const getConflictExceptionsFailureAction = (error: any) => ({
  type: actionTypes.GET_CONFLICT_EXCEPTIONS_FAILURE,
  error,
});

export const editConflictExceptionAction = (payload: any) => ({
  type: actionTypes.EDIT_CONFLICT_EXCEPTION,
  payload,
});
export const editConflictExceptionSuccessAction = (payload: any) => ({
  type: actionTypes.EDIT_CONFLICT_EXCEPTION_SUCCESS,
  payload,
});
export const editConflictExceptionFailureAction = (error: any) => ({
  type: actionTypes.EDIT_CONFLICT_EXCEPTION_FAILURE,
  error,
});

export const deleteConflictExceptionsAction = (payload: any) => ({
  type: actionTypes.DELETE_CONFLICT_EXCEPTIONS,
  payload,
});
export const deleteConflictExceptionsSuccessAction = (payload: any) => ({
  type: actionTypes.DELETE_CONFLICT_EXCEPTIONS_SUCCESS,
  payload,
});
export const deleteConflictExceptionsFailureAction = (error: any) => ({
  type: actionTypes.DELETE_CONFLICT_EXCEPTIONS_FAILURE,
  error,
});

export const setConflictToModifyAction = (payload: any) => ({
  type: actionTypes.SET_CONFLICT_TO_MODIFY,
  payload,
});

export const getAllCreateExceptionUsersAction = (payload: any) => ({
  type: actionTypes.GET_ALL_CREATE_EXCEPTION_USERS,
  payload,
});
export const getAllCreateExceptionUsersSuccessAction = (payload: any) => ({
  type: actionTypes.GET_ALL_CREATE_EXCEPTION_USERS_SUCCESS,
  payload,
});
export const getAllCreateExceptionUsersFailureAction = (error: any) => ({
  type: actionTypes.GET_ALL_CREATE_EXCEPTION_USERS_FAILURE,
  error,
});

export const setCreateExceptionSelectedUsersAction = (payload: any) => ({
  type: actionTypes.SET_CREATE_EXCEPTION_SELECTED_USERS,
  payload,
});

export const createExceptionAction = (payload: any) => ({
  type: actionTypes.CREATE_EXCEPTION,
  payload,
});
export const createExceptionActionSuccess = (payload: any) => ({
  type: actionTypes.CREATE_EXCEPTION_SUCCESS,
  payload,
});
export const createExceptionActionFailure = (error: any) => ({
  type: actionTypes.CREATE_EXCEPTION_FAILURE,
  error,
});
